import { SineInstrument } from './instruments/implementation/SineInstrument';
import { SawInstrument } from './instruments/implementation/SawInstrument';
import { SamplerInstrument } from './instruments/implementation/SamplerInstrument';
export class AudioManager {
    constructor() {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        this.instruments = new Map();
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 256;
        this.masterGain = this.audioContext.createGain();
        this.masterGain.connect(this.analyser);
        this.analyser.connect(this.audioContext.destination);
    }
    static getInstance() {
        if (!AudioManager.instance) {
            AudioManager.instance = new AudioManager();
            AudioManager.instance.initializeDefaultInstruments();
        }
        return AudioManager.instance;
    }
    // Method to register an instrument.
    static registerInstrument(key, ctor) {
        AudioManager.registry.set(key, ctor);
    }
    // Factory method.
    static createInstrument(key) {
        const InstrumentCtor = AudioManager.registry.get(key);
        return InstrumentCtor ? new InstrumentCtor() : undefined;
    }
    addInstrument(name, instrument) {
        this.instruments.set(name, instrument);
    }
    playNote(instrumentName, frequency, duration = 1) {
        const instrument = this.instruments.get(instrumentName);
        if (instrument) {
            instrument.play(frequency, duration, this.audioContext);
        }
        else {
            console.warn(`Instrument ${instrumentName} not found.`);
        }
    }
    stopNote(instrumentName) {
        if (instrumentName) {
            const instrument = this.instruments.get(instrumentName);
            if (instrument) {
                instrument.stop(this.audioContext);
            }
            else {
                console.warn(`Instrument ${instrumentName} not found.`);
            }
        }
        else {
            this.instruments.forEach((instrument) => instrument.stop(this.audioContext));
        }
    }
    playClick(duration = 0.015, accent = false) {
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();
        const frequency = accent ? 1500 : 1000;
        oscillator.frequency.setValueAtTime(frequency, this.audioContext.currentTime);
        oscillator.connect(gainNode);
        gainNode.connect(this.masterGain);
        gainNode.gain.setValueAtTime(1, this.audioContext.currentTime);
        oscillator.start();
        oscillator.stop(this.audioContext.currentTime + duration);
    }
    getAnalyser() {
        return this.analyser;
    }
    initializeDefaultInstruments() {
        this.addInstrument('sampler', new SamplerInstrument());
        this.addInstrument('sine', new SineInstrument());
        this.addInstrument('saw', new SawInstrument());
    }
    getInstrumentNames() {
        return Array.from(this.instruments.keys());
    }
    createOscillator(frequency, audioContext) {
        const oscillator = audioContext.createOscillator();
        oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
        return oscillator;
    }
}
// Static registry for instrument constructors.
AudioManager.registry = new Map();
export default AudioManager;
